import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { GatePassPermissions } from './permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
  perm: string,
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Gate pass route page export "${exportName}" not found`)
  }
  return { Component: createPermissionGuardedPage(perm, Page, { mode: 'any' }) }
}

export const gatePassRoutes: RouteObject[] = [
  {
    path: 'gate-pass',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/supervisor-gate-pass-page'),
        'SupervisorGatePassPage',
        GatePassPermissions.selfRequest,
      ),
  },
  {
    path: 'admin/gate-passes',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/admin-gate-pass-queue-page'),
        'AdminGatePassQueuePage',
        GatePassPermissions.approve,
      ),
  },
  {
    path: 'admin/gate-passes/:requestId',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/admin-gate-pass-detail-page'),
        'AdminGatePassDetailPage',
        GatePassPermissions.approve,
      ),
  },
  {
    path: 'hr/gate-passes',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/hr-gate-pass-queue-page'),
        'HrGatePassQueuePage',
        GatePassPermissions.issue,
      ),
  },
  {
    path: 'hr/gate-passes/register',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/hr-gate-pass-register-page'),
        'HrGatePassRegisterPage',
        GatePassPermissions.issue,
      ),
  },
  {
    path: 'hr/gate-passes/:requestId',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/hr-gate-pass-detail-page'),
        'HrGatePassDetailPage',
        GatePassPermissions.issue,
      ),
  },
]
